/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
import Fondo from '../components/images/fondo.png';
// assets
import HomeFutbol from '../components/images/home/home-futbol.png';
import HomePadel from '../components/images/home/home-padel.png';
import HomeTennis from '../components/images/home/home-tennis.png';
import HomeBasket from '../components/images/home/home-basket.png';

//ball
import BalonFutbol from '../components/images/sports/futbol/balonNav.svg';
import BalonTenis from '../components/images/sports/tenis/balonNav.svg';
import BalonPadel from '../components/images/sports/padel/balonNav.svg';
import BalonBasquetbol from '../components/images/sports/basquetbol/balonNav.svg';

//futbol
//icons
import ArriendaIconsFutbol from '../components/images/sports/futbol/icons/arrienda@2x.png';
import DesafiaIconsFutbol from '../components/images/sports/futbol/icons/desafia@2x.png';
import IntegraIconsFutbol from '../components/images/sports/futbol/icons/integrar@2x.png';
import TorneoIconsFutbol from '../components/images/sports/futbol/icons/torneo@2x.png';

//fondos
import ArriendaFutbol from '../components/images/sports/futbol/arrienda@2x.png';
import IntegraFutbol from '../components/images/sports/futbol/integra@2x.png';
import TorneoFutbol from '../components/images/sports/futbol/torneo@2x.png';
import DesafiaFutbol from '../components/images/sports/futbol/desafia@2x.png';

//tenis
//icons
import ArriendaIconsTenis from '../components/images/sports/tenis/icons/arrienda@2x.png';
import DesafiaIconsTenis from '../components/images/sports/tenis/icons/desafia@2x.png';
import IntegraIconsTenis from '../components/images/sports/tenis/icons/integrar@2x.png';
import TorneoIconsTenis from '../components/images/sports/tenis/icons/torneo@2x.png';

//fondos
import ArriendaTenis from '../components/images/sports/tenis/arrienda@2x.png';
import IntegraTenis from '../components/images/sports/tenis/integra@2x.png';
import TorneoTenis from '../components/images/sports/tenis/torneo@2x.png';
import DesafiaTenis from '../components/images/sports/tenis/desafia@2x.png';

//padel
//icons
import ArriendaIconsPadel from '../components/images/sports/padel/icons/arrienda@2x.png';
import DesafiaIconsPadel from '../components/images/sports/padel/icons/desafia@2x.png';
import IntegraIconsPadel from '../components/images/sports/padel/icons/integrar@2x.png';
import TorneoIconsPadel from '../components/images/sports/padel/icons/torneo@2x.png';

//fondos
import ArriendaPadel from '../components/images/sports/padel/arrienda@2x.png';
import IntegraPadel from '../components/images/sports/padel/integra@2x.png';
import TorneoPadel from '../components/images/sports/padel/torneo@2x.png';
import DesafiaPadel from '../components/images/sports/padel/desafia@2x.png';

//basquetbol
//icons
import ArriendaIconsBasquetbol from '../components/images/sports/basquetbol/icons/arrienda@2x.png';
import DesafiaIconsBasquetbol from '../components/images/sports/basquetbol/icons/desafia@2x.png';
import IntegraIconsBasquetbol from '../components/images/sports/basquetbol/icons/integrar@2x.png';
import TorneoIconsBasquetbol from '../components/images/sports/basquetbol/icons/torneo@2x.png';

//fondos
import ArriendaBasquetbol from '../components/images/sports/basquetbol/arrienda@2x.png';
import IntegraBasquetbol from '../components/images/sports/basquetbol/integra@2x.png';
import TorneoBasquetbol from '../components/images/sports/basquetbol/torneo@2x.png';
import DesafiaBasquetbol from '../components/images/sports/basquetbol/desafia@2x.png';

import { ISports } from '../interfaces';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import _ from 'lodash';

export const getStateListSports = (): Array<ISports> => {
    const selectListSport = (state: any) => state.listSport;
    const listSport = useSelector(selectListSport);
    if (listSport && listSport.data && listSport.data.items && listSport.data.items.length > 0) {
        return listSport.data.items.map((s) => {
            return { id: s.id, name: s.name, key: s.slug };
        });
    } else {
        return [];
    }
};

export const mergeByKey = (arr1: [], arr2: [], key: string): Array<any> => {
    const criteria = {};
    criteria[key] = null;
    return _.map(arr1, function (item) {
        criteria[key] = item[key];
        return _.merge(item, _.find(arr2, criteria));
    });
};

export const sportsApi = (): Array<ISports> => {
    const listSport = getStateListSports();
    if (listSport && listSport.length > 0) {
        const sportBase = [
            {
                key: 'futbol',
                url: '/futbol',
                image: HomeFutbol,
                title: 'FÚTBOL',
                alt: 'Seleccionar Fútbol',
                ball: BalonFutbol,
                color: '',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsFutbol,
                    desafia: DesafiaIconsFutbol,
                    integra: IntegraIconsFutbol,
                    torneo: TorneoIconsFutbol,
                },
                backgrounds: {
                    arrienda: ArriendaFutbol,
                    desafia: DesafiaFutbol,
                    integra: IntegraFutbol,
                    torneo: TorneoFutbol,
                },
            },
            {
                key: 'padel',
                url: '/padel',
                image: HomePadel,
                title: 'PÁDEL',
                alt: 'Seleccionar Padel',
                ball: BalonPadel,
                color: '',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsPadel,
                    desafia: DesafiaIconsPadel,
                    integra: IntegraIconsPadel,
                    torneo: TorneoIconsPadel,
                },
                backgrounds: {
                    arrienda: ArriendaPadel,
                    desafia: DesafiaPadel,
                    integra: IntegraPadel,
                    torneo: TorneoPadel,
                },
            },
            {
                key: 'tenis',
                url: '/tenis',
                image: HomeTennis,
                title: 'TENIS',
                alt: 'Seleccionar Tenis',
                ball: BalonTenis,
                color: '',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsTenis,
                    desafia: DesafiaIconsTenis,
                    integra: IntegraIconsTenis,
                    torneo: TorneoIconsTenis,
                },
                backgrounds: {
                    arrienda: ArriendaTenis,
                    desafia: DesafiaTenis,
                    integra: IntegraTenis,
                    torneo: TorneoTenis,
                },
            },
            {
                key: 'basquetbol',
                url: '/basquetbol',
                image: HomeBasket,
                title: 'BÁSQUETBOL',
                alt: 'Seleccionar Baloncesto',
                ball: BalonBasquetbol,
                color: '',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsBasquetbol,
                    desafia: DesafiaIconsBasquetbol,
                    integra: IntegraIconsBasquetbol,
                    torneo: TorneoIconsBasquetbol,
                },
                backgrounds: {
                    arrienda: ArriendaBasquetbol,
                    desafia: DesafiaBasquetbol,
                    integra: IntegraBasquetbol,
                    torneo: TorneoBasquetbol,
                },
            },
        ];
        const sports = _.mergeByKey(sportBase, listSport, 'key');
        console.log({ listSport, sportBase });
        return sports;
    } else {
        const sports = [
            {
                key: 'futbol',
                url: '/futbol',
                image: HomeFutbol,
                title: 'FÚTBOL',
                alt: 'Seleccionar Fútbol',
                name: 'Fútbol',
                ball: BalonFutbol,
                color: '',
                id: '72001df3-6637-4876-af3f-e67c0ace9825',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsFutbol,
                    desafia: DesafiaIconsFutbol,
                    integra: IntegraIconsFutbol,
                    torneo: TorneoIconsFutbol,
                },
                backgrounds: {
                    arrienda: ArriendaFutbol,
                    desafia: DesafiaFutbol,
                    integra: IntegraFutbol,
                    torneo: TorneoFutbol,
                },
            },
            {
                key: 'padel',
                url: '/padel',
                image: HomePadel,
                title: 'PÁDEL',
                alt: 'Seleccionar Padel',
                name: 'Pádel',
                ball: BalonPadel,
                color: '',
                id: '3dc2c668-8453-43d0-918d-caf544a7f224',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsPadel,
                    desafia: DesafiaIconsPadel,
                    integra: IntegraIconsPadel,
                    torneo: TorneoIconsPadel,
                },
                backgrounds: {
                    arrienda: ArriendaPadel,
                    desafia: DesafiaPadel,
                    integra: IntegraPadel,
                    torneo: TorneoPadel,
                },
            },
            {
                key: 'tenis',
                url: '/tenis',
                image: HomeTennis,
                title: 'TENIS',
                alt: 'Seleccionar Tenis',
                name: 'Tenis',
                ball: BalonTenis,
                color: '',
                id: '6bc86da8-fe14-4374-a50b-4957179d7344',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsTenis,
                    desafia: DesafiaIconsTenis,
                    integra: IntegraIconsTenis,
                    torneo: TorneoIconsTenis,
                },
                backgrounds: {
                    arrienda: ArriendaTenis,
                    desafia: DesafiaTenis,
                    integra: IntegraTenis,
                    torneo: TorneoTenis,
                },
            },
            {
                key: 'basquetbol',
                url: '/basquetbol',
                image: HomeBasket,
                title: 'BÁSQUETBOL',
                alt: 'Seleccionar Baloncesto',
                name: 'Básquetbol',
                ball: BalonBasquetbol,
                color: '',
                id: '5e628310-b469-4769-9726-f2f8731bb51e',
                bg: Fondo,
                icons: {
                    arrienda: ArriendaIconsBasquetbol,
                    desafia: DesafiaIconsBasquetbol,
                    integra: IntegraIconsBasquetbol,
                    torneo: TorneoIconsBasquetbol,
                },
                backgrounds: {
                    arrienda: ArriendaBasquetbol,
                    desafia: DesafiaBasquetbol,
                    integra: IntegraBasquetbol,
                    torneo: TorneoBasquetbol,
                },
            },
        ];
        return sports;
    }
};

export const sports = (): Array<ISports> => {
    const sports = [
        {
            key: 'futbol',
            url: '/futbol',
            image: HomeFutbol,
            title: 'FÚTBOL',
            alt: 'Seleccionar Fútbol',
            name: 'Fútbol',
            ball: BalonFutbol,
            color: '',
            id: '72001df3-6637-4876-af3f-e67c0ace9825',
            bg: Fondo,
            icons: {
                arrienda: ArriendaIconsFutbol,
                desafia: DesafiaIconsFutbol,
                integra: IntegraIconsFutbol,
                torneo: TorneoIconsFutbol,
            },
            backgrounds: {
                arrienda: ArriendaFutbol,
                desafia: DesafiaFutbol,
                integra: IntegraFutbol,
                torneo: TorneoFutbol,
            },
        },
        {
            key: 'padel',
            url: '/padel',
            image: HomePadel,
            title: 'PÁDEL',
            alt: 'Seleccionar Padel',
            name: 'Pádel',
            ball: BalonPadel,
            color: '',
            id: '3dc2c668-8453-43d0-918d-caf544a7f224',
            bg: Fondo,
            icons: {
                arrienda: ArriendaIconsPadel,
                desafia: DesafiaIconsPadel,
                integra: IntegraIconsPadel,
                torneo: TorneoIconsPadel,
            },
            backgrounds: {
                arrienda: ArriendaPadel,
                desafia: DesafiaPadel,
                integra: IntegraPadel,
                torneo: TorneoPadel,
            },
        },
        {
            key: 'tenis',
            url: '/tenis',
            image: HomeTennis,
            title: 'TENIS',
            alt: 'Seleccionar Tenis',
            name: 'Tenis',
            ball: BalonTenis,
            color: '',
            id: '6bc86da8-fe14-4374-a50b-4957179d7344',
            bg: Fondo,
            icons: {
                arrienda: ArriendaIconsTenis,
                desafia: DesafiaIconsTenis,
                integra: IntegraIconsTenis,
                torneo: TorneoIconsTenis,
            },
            backgrounds: {
                arrienda: ArriendaTenis,
                desafia: DesafiaTenis,
                integra: IntegraTenis,
                torneo: TorneoTenis,
            },
        },
        {
            key: 'basquetbol',
            url: '/basquetbol',
            image: HomeBasket,
            title: 'BÁSQUETBOL',
            alt: 'Seleccionar Baloncesto',
            name: 'Básquetbol',
            ball: BalonBasquetbol,
            color: '',
            id: '5e628310-b469-4769-9726-f2f8731bb51e',
            bg: Fondo,
            icons: {
                arrienda: ArriendaIconsBasquetbol,
                desafia: DesafiaIconsBasquetbol,
                integra: IntegraIconsBasquetbol,
                torneo: TorneoIconsBasquetbol,
            },
            backgrounds: {
                arrienda: ArriendaBasquetbol,
                desafia: DesafiaBasquetbol,
                integra: IntegraBasquetbol,
                torneo: TorneoBasquetbol,
            },
        },
    ];
    return sports;
};

export const getIdSports = (key: string): string => {
    const sport = sports().find((s) => s.key === key);
    return sport.id;
};

export const getNameSports = (id: string): string => {
    const sport = sports().find((s) => s.id === id);
    return sport.url;
};

export const getSports = (): ISports => {
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    return sports().find((s) => s.key === sport);
};
